export default origin = [
  {
    type: "zs",
    start: "2026-01-01",
    end: "2031-01-01",
    range: 60,
    interest: 0,
    dateType: "months",
    amount: 49,
    rate: 2,
  },
  {
    type: "zgc",
    start: "2023-02-14",
    end: "2028-02-14",
    range: 7,
    interest: 37,
    dateType: "days",
    amount: 5,
    rate: 3.8,
  },
  {
    type: "zgc",
    start: "2023-02-20",
    end: "2028-02-20",
    range: 7,
    interest: 37,
    dateType: "days",
    amount: 5,
    rate: 3.8,
  },
  {
    type: "zgc",
    start: "2022-11-13",
    end: "2027-05-13",
    range: 3,
    interest: 500,
    dateType: "months",
    amount: 5,
    rate: 4,
  },
  {
    type: "zgc",
    start: "2022-10-29",
    end: "2027-07-29",
    range: 3,
    interest: 500,
    dateType: "months",
    amount: 5,
    rate: 4,
  },
  {
    type: "zgc",
    start: "2022-11-30",
    end: "2027-11-30",
    range: 3,
    interest: 500,
    dateType: "months",
    amount: 5,
    rate: 4,
    keepDay: true,
  },
  {
    type: "zgc",
    start: "2023-02-01",
    end: "2027-11-01",
    range: 3,
    interest: 500,
    dateType: "months",
    amount: 5,
    rate: 4,
  },
  {
    type: "zgc",
    start: "2023-02-24",
    end: "2028-02-24",
    range: 3,
    interest: 500,
    dateType: "months",
    amount: 5,
    rate: 4,
  },
  {
    type: "zgc",
    start: "2023-09-22",
    end: "2028-09-22",
    range: 3,
    interest: 437,
    dateType: "months",
    amount: 5,
    rate: 3.5,
  },
  {
    type: "zgc",
    start: "2024-01-27",
    end: "2029-01-27",
    range: 3,
    interest: 430,
    dateType: "months",
    amount: 5,
    rate: 3.45,
  },
  {
    type: "zgc",
    start: "2024-04-06",
    end: "2029-04-06",
    range: 3,
    interest: 393,
    dateType: "months",
    amount: 5,
    rate: 3.15,
  },
  {
    type: "zgc",
    start: "2024-03-25",
    end: "2029-03-25",
    range: 3,
    interest: 418,
    dateType: "months",
    amount: 5,
    rate: 3.35,
  },
  {
    type: "zgc",
    start: "2024-05-04",
    end: "2029-05-04",
    range: 3,
    interest: 393,
    dateType: "months",
    amount: 5,
    rate: 3.15,
  },
  {
    type: "zgc",
    start: "2024-05-17",
    end: "2027-05-17",
    range: 3,
    interest: 362,
    dateType: "months",
    amount: 5,
    rate: 2.9,
  },
  {
    type: "fm",
    start: "2025-10-17",
    end: "2027-10-17",
    range: 24,
    interest: 4706,
    dateType: "months",
    amount: 10,
    rate: 2.35,
  },
  {
    type: "fm",
    start: "2026-02-25",
    end: "2028-02-25",
    range: 24,
    interest: 4706,
    dateType: "months",
    amount: 10,
    rate: 2.35,
  },
  {
    type: "fm",
    start: "2026-03-21",
    end: "2028-03-21",
    range: 24,
    interest: 2353,
    dateType: "months",
    amount: 5,
    rate: 2.35,
  },
  {
    type: "fm",
    start: "2026-04-01",
    end: "2028-04-01",
    range: 24,
    interest: 4706,
    dateType: "months",
    amount: 10,
    rate: 2.35,
  },
  {
    type: "fm",
    start: "2026-04-12",
    end: "2028-04-12",
    range: 24,
    interest: 2353,
    dateType: "months",
    amount: 5,
    rate: 2.35,
  },
  {
    type: "fm",
    start: "2026-05-13",
    end: "2028-05-13",
    range: 24,
    interest: 2253,
    dateType: "months",
    amount: 5,
    rate: 2.25,
  },
  {
    type: "fm",
    start: "2026-05-26",
    end: "2028-05-26",
    range: 24,
    interest: 2253,
    dateType: "months",
    amount: 5,
    rate: 2.25,
  },
  {
    type: "fm",
    start: "2026-06-04",
    end: "2028-06-04",
    range: 24,
    interest: 2253,
    dateType: "months",
    amount: 5,
    rate: 2.25,
  },
  {
    type: "jc",
    start: "2024-08-18",
    end: "2027-08-18",
    range: 36,
    interest: 4562,
    dateType: "months",
    amount: 5,
    rate: 3,
  },
  {
    type: "jc",
    start: "2024-10-11",
    end: "2027-10-11",
    range: 36,
    interest: 4562,
    dateType: "months",
    amount: 5,
    rate: 3,
  },
  {
    type: "jc",
    start: "2025-02-14",
    end: "2028-02-14",
    range: 36,
    interest: 4258,
    dateType: "months",
    amount: 5,
    rate: 2.8,
  },
  {
    type: "jc",
    start: "2024-07-05",
    end: "2029-07-05",
    range: 60,
    interest: 7608,
    dateType: "months",
    amount: 5,
    rate: 3,
  },
  {
    type: "jc",
    start: "2026-01-19",
    end: "2028-01-19",
    range: 24,
    interest: 4055,
    dateType: "months",
    amount: 10,
    rate: 2,
  },
  {
    type: "jc",
    start: "2026-01-29",
    end: "2028-01-29",
    range: 24,
    interest: 2027,
    dateType: "months",
    amount: 5,
    rate: 2,
  },
  {
    type: "jc",
    start: "2026-01-30",
    end: "2028-01-30",
    range: 24,
    interest: 2027,
    dateType: "months",
    amount: 5,
    rate: 2,
  },
];
